/* RESPONSIBLE TEAM: team-inbox-management */
import { inject as service } from '@ember/service';
import SettingsRoute from 'embercom/routes/apps/app/settings/base/base-settings-route';

export default SettingsRoute.extend({
  intercomEventService: service(),
  permissionsService: service(),

  beforeModel(transition) {
    this._super(...arguments);
    this.permissionsService.ensurePermissionWhenTransitioning(
      'can_access_billing_settings',
      transition,
    );
  },
});
